"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tab = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _atoms = require("../../../atoms");

require("./Tab.css");

var _excluded = ["onSelect", "icon", "iconSize", "id", "index", "exact", "title", "toLocation", "trkContext", "trkAction", "trkLabel"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Tab = function Tab(_ref) {
  var onSelect = _ref.onSelect,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      id = _ref.id,
      index = _ref.index,
      exact = _ref.exact,
      title = _ref.title,
      toLocation = _ref.toLocation,
      trkContext = _ref.trkContext,
      trkAction = _ref.trkAction,
      trkLabel = _ref.trkLabel,
      props = _objectWithoutProperties(_ref, _excluded);

  var handleClick = function handleClick() {
    if (typeof onSelect === 'function') {
      onSelect(id, index);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, _extends({
    "data-trk-ctx": trkContext,
    "data-trk-act": trkAction,
    "data-trk-lbl": trkLabel,
    className: "Tab",
    to: toLocation,
    exact: exact,
    activeClassName: "selected"
  }, props), /*#__PURE__*/_react.default.createElement(_atoms.Row, {
    className: "tab-row",
    onClick: handleClick,
    spacingTop: "4",
    spacingBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
    size: iconSize ? iconSize : 16,
    type: icon
  }), /*#__PURE__*/_react.default.createElement(_atoms.Label, {
    className: "tab-label",
    bold: true,
    center: true
  }, title)));
};

exports.Tab = Tab;